
export interface NavLink {
  label: string;
  path: string;
  onClick?: (e: React.MouseEvent) => void;
  subLinks?: NavLink[];
}

export const createNavLinks = (handleFAQClick: (e: React.MouseEvent) => void): NavLink[] => [
  { label: 'Accueil', path: '/home' },
  {
    label: 'Particuliers',
    path: '/univers-particuliers',
    subLinks: [
      { label: 'Évènements privés', path: '/univers-particuliers' },
      { label: 'Prestations à la carte', path: '/nos-offres' },
      { label: 'Nos lieux partenaires', path: '/lieux' },
      { label: 'Notre prospectus', path: '/prospectus-particuliers' }
    ]
  },
  {
    label: 'Professionnels',
    path: '/evenement-entreprise-prestige',
    subLinks: [
      { label: 'Évènements professionnels', path: '/evenement-entreprise-prestige' },
      { label: 'Conciergerie Corporate', path: '/conciergerie-corporate' },
      { label: 'Devenir partenaire', path: '/devenir-partenaire' },
      { label: 'Notre prospectus', path: '/prospectus-professionnels' }
    ]
  },
  {
    label: 'Collectivités',
    path: '/evenementiel-collectivites',
    subLinks: [
      { label: 'Évènements institutionnels', path: '/evenementiel-collectivites' },
      { label: 'Évènements de mairie', path: '/organisation-evenement-mairie-paris' },
      { label: 'Notre prospectus', path: '/prospectus-collectivites' }
    ]
  },

  { label: 'Nos Réalisations', path: '/nos-realisations' },
  { 
    label: 'Support & Documentation', 
    path: '/support',
    subLinks: [
      { label: 'Notre Blog', path: '/blog' },
      { label: 'À propos', path: '/a-propos' },
      { label: 'FAQ', path: '/faq' },
      { label: 'Charte d\'Excellence', path: '/charte-excellence' },
      { label: 'Nous contacter', path: '/contact' }
    ]
  }
];

export const getFilteredNavLinks = (navLinks: NavLink[]) => 
  navLinks.filter(link => link.label !== 'Accueil' && link.label !== 'Avis clients');
